import { baseApi } from "./baseApi";

const SHIPMENT_LOADING_BASE_URL = "/shipment-loading";

export const ShipmentLoadingApi = baseApi.injectEndpoints({
  tagTypes: ["ShipmentLoading", "Vehicle"],

  endpoints: (builder) => ({
    addShipmentLoading: builder.mutation({
      query: (payLoad) => ({
        url: SHIPMENT_LOADING_BASE_URL,
        method: "POST",
        body: payLoad,
      }),
      invalidatesTags: (result, _error, _arg) => {
        const tags = [
          { type: "ShipmentLoading", id: "LIST" },
          { type: "Shipment", id: "LIST" },
        ];

        if (result?.shipmentId) {
          result.shipmentId.forEach((id) => {
            tags.push({ type: "Shipment", id });
          });
        }

        if (result?._id) {
          tags.push({ type: "ShipmentLoading", id: result._id });
        }

        return tags;
      },
    }),

    listShipmentLoading: builder.query({
      query: (params) => ({
        url: SHIPMENT_LOADING_BASE_URL,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result?.data?.map(({ _id }) => ({
                type: "ShipmentLoading",
                _id,
              })),
              { type: "ShipmentLoading", id: "LIST" },
            ]
          : [{ type: "ShipmentLoading", id: "LIST" }],
    }),

    listShipmentLoadingCount: builder.query({
      query: (params) => ({
        url: `${SHIPMENT_LOADING_BASE_URL}/loadingCount`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result?.data?.map(({ _id }) => ({
                type: "ShipmentLoading",
                _id,
              })),
              { type: "ShipmentLoading", id: "LIST" },
            ]
          : [{ type: "ShipmentLoading", id: "LIST" }],
    }),

    getDDLShipmentLoadingList: builder.query({
      query: (params) => ({ url: `${SHIPMENT_LOADING_BASE_URL}/ddl`, params }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result?.data?.map(({ _id }) => ({
                type: "ShipmentLoading",
                _id,
              })),
              { type: "ShipmentLoading", id: "DDL" },
            ]
          : [{ type: "ShipmentLoading", id: "DDL" }],
    }),

    getDDLShipmentLoadingWithDetails: builder.query({
      query: (params) => ({
        url: `${SHIPMENT_LOADING_BASE_URL}/ddl/with-shipment-info`,
        params,
      }),
      providesTags: (result) =>
        result?.length
          ? [
              ...result.map(({ _id }) => ({
                type: "ShipmentLoading",
                id: _id,
              })),
              { type: "ShipmentLoading", id: "DDL_WITH_DETAILS" },
            ]
          : [{ type: "ShipmentLoading", id: "DDL_WITH_DETAILS" }],
    }),

    getShipmentLoadingDetail: builder.query({
      query: (loadingId) => `${SHIPMENT_LOADING_BASE_URL}/${loadingId}`,
      providesTags: (_result, _error, { _id }) => [
        { type: "ShipmentLoading", _id },
        { type: "ShipmentLoading", id: "LIST" },
      ],
    }),

    getTransitShipmentCount: builder.query({
      query: ({ driverId }) => ({
        url: `${SHIPMENT_LOADING_BASE_URL}/transit-shipment-count`,
        params: { driverId },
      }),
      providesTags: ["ShipmentLoading"],
    }),

    updateShipmentLoading: builder.mutation({
      query: ({ _id, ...body }) => ({
        url: `${SHIPMENT_LOADING_BASE_URL}/${_id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (_result, _error, { _id: id }) => [
        { type: "ShipmentLoading", id },
        { type: "ShipmentLoading", id: "LIST" },
      ],
    }),

    listShipmentsByLoadingIds: builder.query({
      query: ({ loadingId, page, limit }) => ({
        url: `${SHIPMENT_LOADING_BASE_URL}/${loadingId}/shipments`,
        params: { page, limit },
      }),
      providesTags: (result, error, { loadingId }) =>
        result?.data
          ? [
              ...result.data.map(({ _id }) => ({
                type: "ShipmentLoading",
                id: _id,
              })),
              { type: "ShipmentLoading", id: loadingId },
              { type: "ShipmentLoading", id: "LIST" },
            ]
          : [
              { type: "ShipmentLoading", id: loadingId },
              { type: "ShipmentLoading", id: "LIST" },
            ],
    }),
    getManifestoDetailsByLoadingIds: builder.mutation({
      query: (loadingIds) => ({
        url: `${SHIPMENT_LOADING_BASE_URL}/${loadingIds}/manifesto/multiple`,
        method: "POST",
        body: { loadingIds },
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ _id }) => ({
                type: "ShipmentLoading",
                id: _id,
              })),
              { type: "ShipmentLoading", id: "LIST" },
            ]
          : [{ type: "ShipmentLoading", id: "LIST" }],
    }),

    getDDLConsolidationShipments: builder.query({
      query: ({ account, entity, status }) => ({
        url: `${SHIPMENT_LOADING_BASE_URL}/consolidated-shipment`,
        params: { account, entity, status },
      }),
      transformResponse: (response) => response.data,
    }),
    getDDLShipmentLoadingByDriverId: builder.query({
      query: (params) => ({
        url: `${SHIPMENT_LOADING_BASE_URL}/ddl-by-driver`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result?.data?.map(({ loadingId }) => ({
                type: "ShipmentLoading",
                id: loadingId,
              })),
              { type: "ShipmentLoading", id: "DDL_BY_DRIVER" },
            ]
          : [{ type: "ShipmentLoading", id: "DDL_BY_DRIVER" }],
    }),
    // getDDLShipmentLoadingByDriverIdAndBranch: builder.query({
    //   query: (params) => {
    //     return {
    //       url: `${SHIPMENT_LOADING_BASE_URL}/ddl-driver-branch`,
    //       params: {
    //         driverId: params?.driverId,
    //         unLoadedBranchId: params?.unLoadedBranchId,
    //         transitBranchId: params?.transitBranchId, // Add this line
    //       },
    //     };
    //   },
    //   providesTags: (result) =>
    //     result?.data
    //       ? [
    //           ...result?.data?.map(({ _id }) => ({
    //             type: "ShipmentLoading",
    //             id: _id,
    //           })),
    //           { type: "ShipmentLoading", id: "DDL_BY_DRIVER_BRANCH" },
    //         ]
    //       : [{ type: "ShipmentLoading", id: "DDL_BY_DRIVER_BRANCH" }],
    // }),

    getDdlLoadingByDriverIdBranchWise: builder.query({
      query: (params) => ({
        url: `${SHIPMENT_LOADING_BASE_URL}/ddl-by-driver-branchWise`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result?.data?.map(({ loadingId }) => ({
                type: "ShipmentLoading",
                id: loadingId,
              })),
              { type: "ShipmentLoading", id: "DDL_BY_DRIVER" },
            ]
          : [{ type: "ShipmentLoading", id: "DDL_BY_DRIVER" }],
    }),

    getVehiclesWithLoadingStatus: builder.query({
      query: (params) => ({
        url: `${SHIPMENT_LOADING_BASE_URL}/vehicles/loading-status`,
        params,
      }),
      transformResponse: (response) => ({
        vehicles: response.data,
        totalItems: response.totalItems,
      }),
      providesTags: (result) =>
        result?.vehicles
          ? [
              ...result.vehicles.map(({ _id }) => ({
                type: "Vehicle",
                id: _id,
              })),
              { type: "Vehicle", id: "LIST" },
            ]
          : [{ type: "Vehicle", id: "LIST" }],
    }),

    searchLoadings: builder.query({
      query: ({ account, entity, query }) => ({
        url: `${SHIPMENT_LOADING_BASE_URL}/search`,
        params: { account, entity, query },
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result?.data?.map(({ _id }) => ({
                type: "ShipmentLoading",
                _id,
              })),
              { type: "ShipmentLoading", id: "SEARCH" },
            ]
          : [{ type: "ShipmentLoading", id: "SEARCH" }],
    }),

    searchLoadingsWithDetails: builder.query({
      query: ({ account, entity, query }) => ({
        url: `${SHIPMENT_LOADING_BASE_URL}/search-with-details`,
        params: { account, entity, query },
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result?.data?.map(({ _id }) => ({
                type: "ShipmentLoading",
                _id,
              })),
              { type: "ShipmentLoading", id: "SEARCH_DETAILS" },
            ]
          : [{ type: "ShipmentLoading", id: "SEARCH_DETAILS" }],
    }),

    getShipmentDetailByVehicleId: builder.query({
      query: ({ vehicleId, page, limit }) => ({
        url: `${SHIPMENT_LOADING_BASE_URL}/vehicle/${vehicleId}/shipment-details`,
        params: { page, limit },
      }),

      providesTags: (result, error, { vehicleId }) =>
        result?.data?.shipments
          ? [
              ...result.data.shipments.map((item, index) => ({
                type: "ShipmentLoading",
                id: `${vehicleId}-${index}`,
              })),
              { type: "ShipmentLoading", id: `VEHICLE-${vehicleId}` },
              { type: "ShipmentLoading", id: "VEHICLE-LOADING-SUMMARY" },
            ]
          : [
              { type: "ShipmentLoading", id: `VEHICLE-${vehicleId}` },
              { type: "ShipmentLoading", id: "VEHICLE-LOADING-SUMMARY" },
            ],
    }),

    // Query
    getShipmentDetailByDriverId: builder.query({
      query: ({ driverId, page, limit }) => ({
        url: `${SHIPMENT_LOADING_BASE_URL}/driver/${driverId}/shipment-details`,
        params: { page, limit },
      }),
      providesTags: (result, error, { driverId }) =>
        result?.data?.shipments
          ? [
              ...result.data.shipments.map((item, index) => ({
                type: "ShipmentLoading",
                id: `${driverId}-${index}`,
              })),
              { type: "ShipmentLoading", id: `DRIVER-${driverId}` },
              { type: "ShipmentLoading", id: "DRIVER-LOADING-SUMMARY" },
            ]
          : [
              { type: "ShipmentLoading", id: `DRIVER-${driverId}` },
              { type: "ShipmentLoading", id: "DRIVER-LOADING-SUMMARY" },
            ],
    }),

    // Mutation
    qrDriverTransferShipment: builder.mutation({
      query: (body) => ({
        url: `${SHIPMENT_LOADING_BASE_URL}/qr-transfer`,
        method: "POST",
        body,
      }),
      invalidatesTags: (result, error, { fromDriverId }) => [
        { type: "ShipmentLoading", id: `DRIVER-${fromDriverId}` },
        { type: "ShipmentLoading", id: "DRIVER-LOADING-SUMMARY" },
      ],
    }),

    // Driver Unloading rtk
    getDdlBranchesForDriverUnloading: builder.query({
      query: ({ driverId }) => ({
        url: `${SHIPMENT_LOADING_BASE_URL}/ddl-branches-driverUnloading`,
        params: { driverId },
      }),
      providesTags: ["ShipmentLoading"],
    }),

getDdlLoadingByDriverIdAndBranch: builder.query({
      query: ({ driverId, destinationBranchIds, transitBranchIds }) => ({
        url: `${SHIPMENT_LOADING_BASE_URL}/ddl-loading-by-driver-branch`,
        params: {
          driverId,
          destinationBranchIds,
          transitBranchIds,
        },
      }),
      providesTags: ["ShipmentLoading"],
    }),

    // Combined endpoint: branches + loadings + shipments in one call (for mobile)
    getDdlDriverUnloadingCombined: builder.query({
      query: ({ driverId }) => ({
        url: `${SHIPMENT_LOADING_BASE_URL}/ddl-driver-unloading-combined`,
        params: { driverId },
      }),
      providesTags: ["ShipmentLoading"],
    }),
  }),
});

export const {
  useAddShipmentLoadingMutation,
  useListShipmentLoadingQuery,
  useLazyListShipmentLoadingQuery,
  useLazyListShipmentLoadingCountQuery,
  useLazyGetDDLShipmentLoadingListQuery,
  useGetShipmentLoadingQuery,
  useGetShipmentLoadingDetailQuery,
  useUpdateShipmentLoadingMutation,

  useListShipmentsByLoadingIdsQuery,
  useLazyListShipmentsByLoadingIdsQuery,

  useGetManifestoDetailsByLoadingIdsMutation,
  useGetDDLShipmentListQuery,
  useLazyGetDDLConsolidationShipmentsQuery,

  useGetDDLShipmentLoadingWithDetailsQuery,
  useLazyGetDDLShipmentLoadingWithDetailsQuery,

  useGetDDLShipmentLoadingByDriverIdQuery,
  useGetDDLShipmentLoadingByDriverIdAndBranchQuery,
  useLazyGetDDLShipmentLoadingByDriverIdAndBranchQuery,
  useGetDdlLoadingByDriverIdBranchWiseQuery,
  useLazyGetDDLShipmentLoadingByDriverIdQuery,

  useGetVehiclesWithLoadingStatusQuery,
  useLazyGetVehiclesWithLoadingStatusQuery,

  useLazySearchLoadingsQuery,
  useLazySearchLoadingsWithDetailsQuery,

  useGetShipmentDetailByVehicleIdQuery,
  useLazyGetShipmentDetailByVehicleIdQuery,

  useLazyGetDdlBranchesForDriverUnloadingQuery,
  useLazyGetDdlLoadingByDriverIdAndBranchQuery,
  useLazyGetDdlDriverUnloadingCombinedQuery,
  useLazyGetTransitShipmentCountQuery,
  useLazyGetShipmentDetailByDriverIdQuery,
  useQrDriverTransferShipmentMutation,
} = ShipmentLoadingApi;
